import Img1 from "../assets/images/press/womanHandReddiCapsule 11.20.14 PM.png"
import Img2 from "../assets/images/press/womanChargerReeddiCapsule.png"
import Img3 from "../assets/images/press/fastcompany.png"
import Img4 from "../assets/images/press/ventureAfrica.png"
import Img5 from "../assets/images/press/peopleWithReeddiCapsule.png"
import Img6 from "../assets/images/press/uOfT.png"
import Img7 from "../assets/images/press/blueGreen.png"
import Img8 from "../assets/images/press/guardian2.png"
import Img9 from "../assets/images/press/business.png"
import Img10 from "../assets/images/press/africaprize.png"
// import Img11 from "../assets/images/press/startup.png"
import Img11 from "../assets/images/press/reeddi.png"
import Img12 from "../assets/images/press/bloomberg-media.webp"
import Img13 from "../assets/images/press/nrc-media.webp"
import Img14 from "../assets/images/press/impact.png"


import ValueImgIcon1 from "../assets/images/about/innovation.svg"
import ValueImg1 from "../assets/images/about/value1.webp"

import ValueImgIcon2 from "../assets/images/about/create.svg"
import ValueImg2 from "../assets/images/about/value2.webp"

import ValueImgIcon3 from "../assets/images/about/decarbon.svg"
import ValueImg3 from "../assets/images/about/value3.webp"

import ValueImgIcon4 from "../assets/images/about/giving.svg"
import ValueImg4 from "../assets/images/about/value4.webp"

import Logo1 from "../assets/images/press/logos/time.svg"
import Logo2 from "../assets/images/press/logos/StartUp.svg"
import Logo3 from "../assets/images/press/logos/fastCompany.svg"
import Logo4 from "../assets/images/press/logos/VA logo.svg"
import Logo5 from "../assets/images/press/logos/thirdDerivative.svg"
import Logo6 from "../assets/images/press/logos/uoft.svg"
import Logo7 from "../assets/images/press/logos/blueGreen.svg"
import Logo8 from "../assets/images/press/logos/The guardian.svg"
import Logo9 from "../assets/images/press/logos/businessday.png"
import Logo10 from "../assets/images/press/logos/royalacademy.svg"
import Logo11 from "../assets/images/press/logos/startup-logo.svg"
import Logo12 from "../assets/images/press/logos/bloomberg.svg"
import Logo13 from "../assets/images/press/logos/nrc.svg"

export const features = [
    {
        id: "1",
        logo: Logo12,
        source: "Bloomberg",
        read: "4 mins read",
        caption:
            "Powering Nigeria One Electric Capsule at a Time",
        link: "https://www.bloomberg.com/news/videos/2023-01-09/powering-nigeria-one-electric-capsule-at-a-time",
        image: Img12,
    },
    {
        id: "2",
        logo: Logo13,
        source: "NRC",
        read: "4 mins read",
        caption:
            "Nigerians Pull Themselves Out Of The Darkness",
        link: "https://www.nrc.nl/nieuws/2023/01/08/nigerianen-halen-zichzelf-uit-de-duisternis-a4153609",
        image: Img13,
    },
    {
        id: "3",
        logo: Logo2,
        source: "STARTUP HERE TORONTO",
        read: "3 mins read",
        caption:
            "How Reeddi went from dorm room dream to Time magazine’s best inventions list",
        link: "https://startupheretoronto.com/type/startup-news/how-reeddi-went-from-dorm-room-dream-to-time-magazines-best-inventions-list/",
        image: Img2,
    },
    {
        id: "4",
        logo: Logo5,
        source: "THIRD DERIVATIVE",
        read: "2 mins read",
        caption: "Ecosystem Spotlight: Reeddi’s Clean Energy-as-a-Service Solution",
        link: "https://www.third-derivative.org/blog/ecosystem-spotlight-reeddis-clean-energy-as-a-service-solution?hsLang=en",
        image: Img5,
    },
    {
        id: "5",
        logo: Logo1,
        source: "TIME MAGAZINE",
        read: "1 min read",
        caption:
            "The best inventions of 2021: Grid-Free Electricity for African Households and Businesses",
        link: "https://time.com/collection/best-inventions-2021/6113115/reeddi",
        image: Img1,
    },
    {
        id: "6",
        logo: Logo6,
        source: "U of T NEWS",
        read: "3 mins read",
        caption:
            "U of T alumnus Olugbenga Olubanjo one of 15 finalists for $1.7-million Earthshot Prize",
        link: "https://www.utoronto.ca/news/u-t-alumnus-olugbenga-olubanjo-one-15-finalists-17-million-earthshot-prize",
        image: Img6,
    },
    {
        id: "7",
        logo: Logo7,
        source: "BLUE & GREEN",
        read: "2 mins read",
        caption:
            "Nigerian Startup Sells Solar-Powered Rechargeable Batteries Locally",
        link: "https://blueandgreentomorrow.com/news/nigerian-startup-sells-solar-powered-rechargeable-batteries-locally/",
        image: Img7,
    },
    {
        id: "8",
        logo: Logo3,
        source: "FAST COMPANY",
        read: "1 min read",
        caption:
            "This Nigerian startup sells solar-powered batteries at corner stores",
        link: "https://www.fastcompany.com/90679524/this-nigerian-startup-sells-solar-powered-batteries-at-corner-stores",
        image: Img3,
    },
    {
        id: "9",
        logo: Logo4,
        source: "VENTURES AFRICA",
        read: "3 mins read",
        caption:
            "Reeddi Capsule is Helping Nigerian Businesses Gain Access To Clean Energy on the Go",
        link: "https://venturesafrica.com/olugbenga-olubanjos-reeddi-capsule-is-helping-nigerian-businesses-gain-access-to-clean-energy-on-the-go/",
        image: Img4,
    },
    {
        id: "10",
        logo: Logo11,
        source: "Startup Energy Transition",
        read: "2 min read",
        caption:
            "Announcing the Top 100 Energy and Mobility Startups of 2021",
        link: "https://www.startup-energy-transition.com/presenting-the-set100-list-2021/",
        image: Img11,
    },
    {
        id: "11",
        logo: Logo8,
        source: "GUARDIAN",
        read: "1 min read",
        caption: "USADF, All On canvass improved power supply",
        link: "https://guardian.ng/business-services/usadf-all-on-canvass-improved-power-supply/",
        image: Img8,
    },
    {
        id: "12",
        logo: Logo6,
        source: "U of T NEWS",
        read: "2 mins read",
        caption:
            "U of T Entrepreneur Creates His Own Job Post-Graduation: Delivering Clean, Affordable Energy to Nigeria",
        link: "https://www.utoronto.ca/news/u-t-entrepreneur-creates-his-own-job-post-graduation-delivering-clean-affordable-energy-nigeria",
        image: Img5,
    },
    {
        id: "13",
        logo: Logo6,
        source: "U of T NEWS",
        read: "2 mins read",
        caption:
            "REEDDI: Putting Power In The Hands Of The People",
        link: "https://civmin.utoronto.ca/reeddi-putting-power-in-the-hands-of-the-people/",
        image: Img14,
    },
];

export const values = [
    {
        id: 1,
        icon: ValueImgIcon1,
        image: ValueImg1,
        title: "Innovation",
        content:
            `We address our target market needs using research-based solutions.
      `,
    },
    {
        id: 2,
        icon: ValueImgIcon2,
        image: ValueImg2,
        title: "Venture Creation",
        content:
            `
      Our innovation opens business opportunities for 
      small and medium-scale enterprises (SMEs) and our stakeholders.
      `,
    },
    {
        id: 3,
        icon: ValueImgIcon3,
        image: ValueImg3,
        title: "Decarbonization",
        content:
            `We design our digital systems to track and reward 
      customers for contributing to reducing greenhouse gas emissions.`,
    },
    {
        id: 4,
        icon: ValueImgIcon4,
        image: ValueImg4,
        title: "Giving Back",
        content:
            `Our products positively contribute to the 
      environment by combating climate change and its impact.`,
    },
];
